// extracted by mini-css-extract-plugin
export default {"profile":"Home_profile__xtIjd","left":"Home_left__bprhP"};